import type { Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCanTgHJu7idvMge9QmklMsD8MygqXTUZg",
  authDomain: "agents-workful-jp.firebaseapp.com",
  projectId: "agents-workful-jp",
  storageBucket: "agents-workful-jp.firebasestorage.app",
  messagingSenderId: "96387126072",
  appId: "1:96387126072:web:54b00d4267354ab7cd27cd",
  measurementId: "G-X1E3QBR148",
};

/**
 * Firebase SDK はまるごと動的 import に逃がしています。
 * このLPが SDK を必要とするのは計測だけで、初期表示を遅らせるとそのまま
 * 離脱につながるためです。非対応環境では null を返し、計測なしで動作を続けます。
 */
let analyticsPromise: Promise<Analytics | null> | null = null;
function getAnalyticsSafe(): Promise<Analytics | null> {
  if (!analyticsPromise) {
    analyticsPromise = (async () => {
      const [{ initializeApp }, analytics] = await Promise.all([
        import("firebase/app"),
        import("firebase/analytics"),
      ]);
      if (!(await analytics.isSupported())) return null;
      return analytics.getAnalytics(initializeApp(firebaseConfig));
    })().catch(() => null);
  }
  return analyticsPromise;
}

/** 計測は失敗しても本体の動作に影響させません */
export async function track(name: string, params?: Record<string, unknown>): Promise<void> {
  try {
    const instance = await getAnalyticsSafe();
    if (!instance) return;
    const { logEvent } = await import("firebase/analytics");
    logEvent(instance, name, params);
  } catch {
    /* 計測できなくても無視します */
  }
}
